var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-order-item",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.showImage && _vm.image ? _c('div', {
    staticClass: "s-order-item-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]) : _vm._e(), _vm.arrangedFieldsForGrid.length > 0 ? [_c('div', {
    staticClass: "s-order-item-info"
  }, _vm._l(_vm.arrangedFieldsForGrid, function (field, j) {
    return _c('div', {
      key: j,
      staticClass: "s-order-item-field"
    }, [field.type === 'ntd' ? [_c('p', {
      staticClass: "s-text-primary"
    }, [_c('span', {
      staticClass: "s-text-sm"
    }, [_vm._v("NT$ ")]), _c('span', {
      staticClass: "s-font-bold"
    }, [_vm._v(_vm._s(_vm.$currency(_vm.getOrderData(field.key), '')))])])] : _vm.getOrderData(field.key) || field.value ? _c('span', {
      class: _vm.getFieldClass(field)
    }, [_vm._v(" " + _vm._s(field.value) + _vm._s(_vm.getOrderData(field.key)) + " ")]) : _vm._e()], 2);
  }), 0)] : [_c('div', {
    staticClass: "s-order-item-info"
  }, [_c('div', {
    staticClass: "s-space-y-2 s-mr-auto"
  }, [_c('p', {
    staticClass: "s-text-gray-darker s-font-semibold"
  }, [_vm._v(" 訂單編號：" + _vm._s(_vm.order.order_number) + " ")]), _c('p', {
    staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.datetime) + " ")])]), _c('div', {
    staticClass: "s-flex s-flex-col s-items-end"
  }, [_c('p', [_c('span', {
    staticClass: "s-tag"
  }, [_vm._v(_vm._s(_vm.order.order_status))])]), _c('p', {
    staticClass: "s-text-primary"
  }, [_c('span', {
    staticClass: "s-text-sm"
  }, [_vm._v("NT$ ")]), _c('span', {
    staticClass: "s-font-bold"
  }, [_vm._v(_vm._s(_vm.$currency(_vm.order.amount, '')))])])])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }